import { createAsyncThunk } from '@reduxjs/toolkit';
import { getSubcontractorEmployeeData } from 'scenes/WorkDemo/services/getSubcontractorEmployeeData.service';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { selectUserActiveEmployerInfo } from 'store/user/selectors.js/user.selectors';

export const loadSubcontractorEmployeeData = createAsyncThunk(
  'workCalendar/loadSubcontractorEmployeeData',
  async (_, { getState }) => {
    const state = getState();
    const selectedProjectId = selectSelectedProjectId(getState());

    const activeEmployerInfo = selectUserActiveEmployerInfo(state);

    const response = await getSubcontractorEmployeeData(
      selectedProjectId,
      activeEmployerInfo
    );

    return response;
  }
);
